module.exports = __webpack_public_path__ + "static/media/ftu.697b92f9.png";